import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import {Drawer, IconButton, Toolbar } from '@mui/material';
import { Close } from '@mui/icons-material';
import Comments from './Comments';

const drawerWidth = 320

export default function CommentsDrawer({openCommentDrawer, setOpenCommentDrawer, blogId, currentUserId}) {

    const toggleDrawer = (open) => (event) => {
      if (
        event &&
        event.type === 'keydown' &&
        (event.key === 'Tab' || event.key === 'Shift')
      ) {
        return;
      }

      openCommentDrawer = open
      setOpenCommentDrawer(openCommentDrawer)
    };
    
  return (
    <>
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer
        anchor="right"
        transitionDuration={500}
        open={openCommentDrawer}
        onClose={toggleDrawer(false)}
        // onOpen={toggleDrawer(true)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <div className='comment-drawer-header'>
          <div className='comment-drawer-heading'>
            Comments
          </div>
          <div className='comment-drawer-back-button'>
            <IconButton onClick={toggleDrawer(false)}>
              <Close/>
            </IconButton>
          </div>
        </div>
        <Box>
          <Comments blogId={blogId} currentUserId={currentUserId}/>
        </Box>
      </Drawer>
    </Box>
    </>
  );
}